// extracted by mini-css-extract-plugin
var _1 = "mmhr4PYiH1kAgbPb3Zw7";
var _2 = "wmyG9E90WXyuLmgpgBPn";
export { _1 as "links", _2 as "root" }
